import React, { useContext, useState } from 'react';
import proptypes from 'prop-types';
const { string } = proptypes;

import {
  Row,
  Button,
  Heading,
} from '@thd-olt-component-react/core-ui';

import { ClearButton } from './ClearButton';
import { InfoCard } from '../info-card/InfoCard';
import { ModalContainer } from '../modal/container/ModalContainer';
import { DeclineClearModalBody } from '../modal/bodies/decline-clear-modal-body/DeclineClearModalBody';

import '../../styles/components/ClearLandingBody.scss';

export const ClearLandingBody = ({ clearState }) => {
  const [showDeclineModal, setShowDeclineModal] = useState(false);

  return (
    <>
      <Row className="landing__body">
        <Heading
          title="Home Depot uses CLEAR for Identity Verification"
          centered
          className="landing__heading"
        />
        <InfoCard
          infoType="LicenseInfo"
          mainHeader="You will need a valid drivers license"
        />
        <InfoCard
          infoType="ProfileInfo"
          mainHeader="The name on your ID will need to match the name on your Rental Contract"
        />
      </Row>
      <Row className="landing__footer">
        <ClearButton clearState={clearState} />
        <Button link onClick={() => setShowDeclineModal(true)}>No thanks</Button>
        <ModalContainer show={showDeclineModal}>
          <DeclineClearModalBody handleClose={setShowDeclineModal} />
        </ModalContainer>
      </Row>
    </>
  );
};

ClearLandingBody.propTypes = {
  clearState: string.isRequired
}